export default {
    statisticProcessBaseData: 'Daten',
    statisticProcessActivities: 'Historie',
}